<script>
    import FileUpload from "../../../../components/FileUpload";
    export default {
        name: "SupplierFileUpload",
        extends: FileUpload
    }
</script>